import React from 'react';
import ReactDOM from 'react-dom';

import './url-values';

import configureStore from './redux/configure';
import history from './routes/history';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import App from './App';

import * as serviceWorker from './serviceWorker';

import '@progress/kendo-theme-material/dist/all.css';
import "../node_modules/video-react/dist/video-react.css";
import './index.css';
import 'core-js';

const initialState = {};

export const { 
    store, 
    persistor 
} = configureStore(initialState);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading="Loading..." persistor={persistor}>
            <App history={history} />
        </PersistGate>
    </Provider>, 
    document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
